import { MICROPHONE_SET, TOGGLE_MIC } from "./types";

const micSet = (micId, micName) => ({
  type: MICROPHONE_SET,
  micId,
  micName,
});

export const micChange = (micId, micName, saveToLS = true) => (dispatch) => {
  if (saveToLS) {
    localStorage.setItem("micId", micId);
    localStorage.setItem("micName", micName);
  }
  dispatch(micSet(micId, micName));
};

export const initMic = () => (dispatch) => {
  const micId = localStorage.getItem("micId") || "default";
  const micName = localStorage.getItem("micName") || "default";
  dispatch(micChange(micId, micName));
};

export const toggleMic = () => ({
  type: TOGGLE_MIC,
});
